import { cn } from "@/lib/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserDashed } from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";
import { DisplayAvatarProps } from "./DisplayAvatar";
import { UserAvatar } from "./UserAvatar";
import { UserDisplayName } from "./UserDisplayName";

const MAX_AVATARS = 3;

type MultipleUserAvatar = {
  users: {
    name: string | null;
    email?: string | null;
    photo_url?: string | null;
  }[];
  className?: string;
  size?: DisplayAvatarProps["size"];
  inlineNames?: boolean;
};

export const MultipleUserAvatar: React.FC<MultipleUserAvatar> = ({
  users,
  className,
  size = "md",
  inlineNames = false,
}) => {
  if (users.length === 0) {
    return (
      <Tooltip>
        <TooltipTrigger>
          <FontAwesomeIcon icon={faUserDashed} className="text-foreground-5" />
        </TooltipTrigger>
        <TooltipContent>No users</TooltipContent>
      </Tooltip>
    );
  }

  return (
    <div className={cn("flex flex-row gap-2", className)}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={cn("flex flex-row-reverse gap-0", className)}>
            {users.map((user) => (
              <UserAvatar
                key={user.name + (user.email ?? "")}
                user={user}
                size={size}
                className="-m-1 box-content border-1 border-white"
              />
            ))}
          </div>
        </TooltipTrigger>
        <TooltipContent className="flex flex-col gap-2">
          {users.map((user) => (
            <UserDisplayName
              key={user.name + (user.email ?? "")}
              user={user}
              variant="default"
            />
          ))}
        </TooltipContent>
      </Tooltip>
      {inlineNames &&
        users.length <= MAX_AVATARS &&
        users
          .slice(0, MAX_AVATARS)
          .map((user) => user.name)
          .join(", ")}

      {users.length > MAX_AVATARS && (
        <div className="text-foreground-5 text-xs">
          + {users.length - MAX_AVATARS}
        </div>
      )}
    </div>
  );
};
